require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconChevronDown.tsx
var IconChevronDown_exports = {};
__export(IconChevronDown_exports, {
  default: () => IconChevronDown_default
});
module.exports = __toCommonJS(IconChevronDown_exports);

// src/assets/monochrome/chevronDown.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgChevronDown = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.79321 6.85279C5.68234 6.74101 5.55041 6.65227 5.40507 6.59172C5.25973 6.53117 5.10387 6.5 4.94642 6.5C4.78897 6.5 4.63308 6.53117 4.48774 6.59172C4.3424 6.65227 4.21047 6.74101 4.0996 6.85279C3.87746 7.07625 3.7528 7.37853 3.7528 7.69361C3.7528 8.00869 3.87746 8.31096 4.0996 8.53442L9.16847 13.6032C9.39193 13.8253 9.69423 13.95 10.0093 13.95C10.3244 13.95 10.6267 13.8253 10.8501 13.6032L15.9071 8.53442C16.1292 8.31096 16.2539 8.00869 16.2539 7.69361C16.2539 7.37853 16.1292 7.07625 15.9071 6.85279C15.6836 6.63066 15.3813 6.50597 15.0663 6.50597C14.7512 6.50597 14.4489 6.63066 14.2254 6.85279L10.0034 11.0748L5.79321 6.85279Z", fill: "#818898" }) });
var chevronDown_default = SvgChevronDown;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconChevronDown.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconChevronDown = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(chevronDown_default, {}) });
};
IconChevronDown.displayName = "IconChevronDown";
var IconChevronDown_default = IconChevronDown;
